import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-inbox-experience }}\n<WelcomeHelpdesk />",{ moduleName: "embercom/templates/apps/app/welcome-helpdesk.hbs" })